<div class="gantt-header">
    <div class="gantt-header-title">
        <div style="flex:1">{{ name }}</div>
        <div>Started: {{ startDate}}</div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/gantt-chart/gantt-header/gantt-header.component.html